import { EmailBoxIcon } from './EmailBoxIcon';

/**
 * author: GreenTurtwig
 * id 6930A4EF-08EB-4649-B2BB-369269DA918F
 * name email-box
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-box.svg
 * tags
 */
export const EnvelopeBoxIcon = EmailBoxIcon;
export default EnvelopeBoxIcon